import { PaymentProcessConstants } from "../constants/paymentprocess.constants";

const PaymentProcessReducer = (state, action) => {
  switch (action.type) {
    case PaymentProcessConstants.FETCH_PAYMENT_PROCESS_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PaymentProcessConstants.FETCH_PAYMENT_PROCESS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentProcesses: action.payload.data,
        paging: action.payload.paging,
      };
    case PaymentProcessConstants.FETCH_PAYMENT_PROCESS_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PaymentProcessConstants.FETCH_DEPOSIT_PAYMENT_PROCESS_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PaymentProcessConstants.FETCH_DEPOSIT_PAYMENT_PROCESS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        depositPaymentProcesses: action.payload.data,
        paging: action.payload.paging,
      };
    case PaymentProcessConstants.FETCH_DEPOSIT_PAYMENT_PROCESS_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PaymentProcessConstants.PAYMENT_PROCESS_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PaymentProcessConstants.PAYMENT_PROCESS_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentProcessSearchResults: action.payload,
      };
    case PaymentProcessConstants.PAYMENT_PROCESS_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PaymentProcessConstants.PAYMENT_PROCESS_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PaymentProcessConstants.PAYMENT_PROCESS_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentProcessAutoSearchResults: action.payload,
      };
    case PaymentProcessConstants.PAYMENT_PROCESS_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PaymentProcessConstants.ADD_PAYMENT_PROCESS_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case PaymentProcessConstants.ADD_PAYMENT_PROCESS_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case PaymentProcessConstants.ADD_PAYMENT_PROCESS_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case PaymentProcessConstants.GET_PAYMENT_PROCESS_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PaymentProcessConstants.GET_PAYMENT_PROCESS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentProcess: action.payload,
      };
    case PaymentProcessConstants.GET_PAYMENT_PROCESS_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PaymentProcessConstants.UPDATE_PAYMENT_PROCESS_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case PaymentProcessConstants.UPDATE_PAYMENT_PROCESS_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        paymentProcess: action.payload,
      };
    case PaymentProcessConstants.UPDATE_PAYMENT_PROCESS_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case PaymentProcessConstants.DOWNLOAD_PAYMENT_PROCESS_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case PaymentProcessConstants.DOWNLOAD_PAYMENT_PROCESS_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case PaymentProcessConstants.DOWNLOAD_PAYMENT_PROCESS_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case PaymentProcessConstants.UPLOAD_PAYMENT_PROCESS_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case PaymentProcessConstants.UPLOAD_PAYMENT_PROCESS_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case PaymentProcessConstants.UPLOAD_PAYMENT_PROCESS_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };

    default:
      return state;
  }
};

export default PaymentProcessReducer;
